const formatDate = (date, utc) => {
  const opts = utc ? { timeZone: 'UTC' } : {};

  Object.assign(opts, { weekday: 'short',
                        month: 'short',
                        day: 'numeric' });
  
  return new Intl.DateTimeFormat('en-US', opts).format(date);
};

const formatTime = (time, utc) => {
  const opts = utc ? { timeZone: 'UTC' } : {};

  Object.assign(opts, { hour: 'numeric',
                        minute: 'numeric' });
  
  return new Intl.DateTimeFormat('en-US', opts).format(time);
};

const formatCurrency = (amount) => {
  const opts = { style: 'currency',
                 minimumFractionDigits: 0,
                 currency: 'USD' };
  
  return new Intl.NumberFormat('en-US', opts).format(amount);
};

export { formatDate, formatTime, formatCurrency }
